import React, { memo, useState } from 'react'
import { CSSTransition } from 'react-transition-group'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import './Collapse.scss'
const rootClassName = 'component-collapse'

interface CollapseProps {
  opened: boolean
  animateOpacity?: boolean
  children?: any
}

function Collapse(props: CollapseProps) {
  const [id] = useState(`collapse${getUniqueKey()}`)
  return (
    <CSSTransition
      in={props.opened}
      timeout={300}
      unmountOnExit
      onEnter={() => {
        const el = document.querySelector(`#${id}`) as HTMLElement
        el.style.height = '0'
        if (props.animateOpacity) {
          el.style.opacity = '0'
        }
      }}
      onEntering={() => {
        const el = document.querySelector(`#${id}`) as HTMLElement
        if (el) {
          const child = el.firstElementChild as HTMLElement
          if (child) {
            const childBounding = child.getBoundingClientRect()
            el.style.height = `${parseFloat(String(childBounding.height))}px`
            if (props.animateOpacity) {
              el.style.opacity = '1'
            }
          }
        }
      }}
      onEntered={() => {
        const el = document.querySelector(`#${id}`) as HTMLElement
        if (el) el.style.height = 'auto'
      }}
      onExit={() => {
        const el = document.querySelector(`#${id}`) as HTMLElement
        if (el) {
          const child = el.firstElementChild as HTMLElement
          if (child) {
            const childBounding = child.getBoundingClientRect()
            el.style.height = `${parseFloat(String(childBounding.height))}px`
            if (props.animateOpacity) {
              el.style.opacity = '1'
            }
          }
        }
      }}
      onExiting={() => {
        const el = document.querySelector(`#${id}`) as HTMLElement
        if (el) {
          el.style.height = '0'
          if (props.animateOpacity) {
            el.style.opacity = '0'
          }
        }
      }}
    >
      <div
        className={getMergedClassNames([
          rootClassName,
          props.animateOpacity ? 'animate-opacity' : ''
        ])}
        id={id}
      >
        <div className={`${rootClassName}-content`}>{props.children}</div>
      </div>
    </CSSTransition>
  )
}

Collapse.defaultProps = {
  children: undefined,
  opened: false
}

export default memo(Collapse)
